/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */

export function fieldsWithValues(form: HTMLFormElement) {
    const fields = [] as Array<HTMLFormElement>
    
    // Loop through each field in the form
    for (let i = 0; i < form.elements.length; i++) {
        const field = form.elements[i] as HTMLFormElement

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name ||
            field.disabled ||
            field.type === 'file' ||
            field.type === 'reset' ||
            field.type === 'submit' ||
            field.type === 'button' ||
            (field.type === 'checkbox' && !field.checked)
        ) continue

        fields.push(field)
    }
    return fields
}

export function valueForField(field: HTMLFormElement) {
    let value:any
    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
        value = []
        for (let n = 0; n < field.options.length; n++) {
            if (field.options[n].selected) {
                value.push(field.options[n].value)
            }
        }
    } else if (field.type === 'checkbox' && field.type === 'radio') {
        value = field.checked
    } else {
        value = field.value
    }
    return value
}

export function serializeForm(form: HTMLFormElement) {
    // Setup our serialized data
    const serialized = Object.create(null)
    const fields = fieldsWithValues(form)
    
    // Loop through each field in the form
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i]
        serialized[field.name] = valueForField(field)
    }

    return serialized
}
